<template>
  <div id="app">
    <transition name="fade">
      <Loading v-if="isLoading"></Loading>
    </transition>

    <div id="container" :class="{ 'is-popup': isPopup }" ref="container">
      <Header></Header>
      <Main></Main>
      <Footer></Footer>
    </div>
    <!-- <Desktop v-else></Desktop> -->
    <transition
      name="fade"
      @before-enter="onPopupBeforeEnter"
      @after-enter="onPopupAfterEnter"
      @before-leave="onPopupBeforeLeave"
      @after-leave="onPopupAfterLeave"
    >
      <div
        id="popup"
        v-if="popup"
        :class="[{ 'popup--ready': isPopupReady }]"
        ref="popup"
      >
        <div class="popup__container">
          <PopupMenu v-if="popup === 'popup-menu'"></PopupMenu>
          <PopupAwards v-if="popup === 'popup-awards'"></PopupAwards>
          <PopupCompany v-if="popup === 'popup-company'"></PopupCompany>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import axios from 'axios';
import { mapActions, mapState } from 'pinia';
import { useMainStore } from '@/store/main';
import { mixins } from '@/utils/mixins';
import 'animate.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

// 預載圖檔 JSON
// import preload from '@/json/preload.json';

import Header from './components/Header.vue';
import Footer from './components/Footer.vue';
import Loading from './components/Loading.vue';
import Main from './containers/Main.vue';
import Desktop from './components/Desktop.vue';
import PopupMenu from './popups/PopupMenu.vue';
import PopupAwards from './popups/PopupAwards.vue';
import PopupCompany from './popups/PopupCompany.vue';

export default {
  name: 'App',
  mixins: [mixins],
  computed: {
    ...mapState(useMainStore, ['isLoading', 'isMobile', 'popup', 'popupQueue']),
  },
  data: () => {
    return {
      isPopup: false,
      isPopupReady: false,
    };
  },
  watch: {
    $route(to, from) {
      // this.preloadImages(to.path);
    },
    // jumpTarget(to, from) {
    //   if (!to, from) return;
    //   this.trackPageview(to)
    // },
  },
  methods: {
    ...mapActions(useMainStore, [
      'setLoading',
      'openPopup',
      'closePopup',
      'clearPopupQueue',
      'setIsMobile',
    ]),
    setCssVariable() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    checkIsMobile() {
      const { setIsMobile } = this;
      setIsMobile(window.matchMedia('(max-width: 1080px)').matches);
    },
    checkIsPopupMenuOpened() {
      const { isMobile, closePopup } = this;
      const { popup } = this;
      if (!isMobile && popup && popup.type === 'menu') closePopup();
    },
    onResize() {
      const { setCssVariable, checkIsMobile, checkIsPopupMenuOpened } = this;
      setCssVariable();
      checkIsMobile();
      checkIsPopupMenuOpened();
    },
    onPopupBeforeEnter() {
      const { popupQueue, clearPopupQueue } = this;
      const { container } = this.$refs;
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop || 0;
      this.isPopup = true;
      container.style.top = -scrollTop + 'px';
      window.scrollTo(0, 0);
      if (popupQueue) clearPopupQueue();
    },
    onPopupAfterEnter() {
      this.isPopupReady = true;
      // const popup = document.querySelector('#popup')
      // popup.classList.add('popup--ready');
    },
    onPopupBeforeLeave() {
      this.isPopupReady = false;
      this.$refs.popup.classList.remove('popup--ready');
      // const popup = document.querySelector('#popup')
      // popup.classList.remove('popup--ready');
    },
    onPopupAfterLeave() {
      const { popupQueue, openPopup } = this;
      const { container } = this.$refs;
      const containerTop = Math.abs(parseInt(container.style.top));
      this.isPopup = false;
      this.isPopupReady = false;
      container.style.top = 0 + 'px';
      this.$nextTick(() => {
        window.scrollTo(0, containerTop);
        if (popupQueue) openPopup({ type: popupQueue });
      });
    },
    trackPageview(elem) {
      // let pv = elem.dataset.pv;
      // this.$trackPage(pv)
    },
    // preloadImages(key) {
    //   const preloadArray = preload[key];
    //   if (preloadArray) {
    //     preloadArray.forEach(item => {
    //       const image = new Image;
    //       image.src = require(`@/assets/images/${item}`);
    //     })
    //   }
    // },
  },
  created() {
    const { onResize, setLoading } = this;
    window.addEventListener('resize', onResize);

    window.addEventListener('load', () => {
      setTimeout(() => {
        setLoading(false);
      }, 250);
    });

    // document.body.addEventListener('touchstart', function() {}, false);

    // if (!this.isDev()) this.$router.push('/').catch(err => {err});

    // const lenis = new Lenis()

    // lenis.on('scroll', (e) => {
    //   console.log(e)
    // })

    // function raf(time) {
    //   lenis.raf(time)
    //   requestAnimationFrame(raf)
    // }

    // requestAnimationFrame(raf)
  },
  mounted() {
    const { setCssVariable, checkIsMobile } = this;

    setCssVariable();
    checkIsMobile();

    AOS.init({
      duration: 600, // 縮短動畫時間
      once: true, // 允許重複播放
      offset: 0, // 調整觸發位置
      delay: 0, // 初始延遲
      easing: 'ease-out-cubic',
      mirror: false, // 允許動畫反向播放
    });
  },
  components: {
    Header,
    Footer,
    Main,
    Loading,
    PopupMenu,
    PopupAwards,
    PopupCompany,
    // Desktop,
  },
};
</script>

<style lang="scss">
:root {
  --move-y: 50px;
  --header-height: #{vhX(135)};

  @include tablet {
    --move-y: #{vw(50)};
    --header-height: #{vw(100)};
  }
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#container {
  position: relative;
  width: 100%;
  margin: 0 auto;

  @include tablet {
  }

  &.is-popup {
    position: fixed;
  }
}

.disabled {
  position: relative;

  a {
    opacity: 0.2;
    pointer-events: none;
  }
}

input[type='text'],
select,
button {
  font-family: $fontFamilyNotoSans;
  font-weight: 500;
  margin: 0;
  padding: 0;
  border: 0;
  border-radius: 0;
  outline: 0;
  appearance: none;
}

select {
  // height: vwXL(70);
  // color: #eb623c;
  // font-size: vwXL(27);
  // font-weight: 700;
  // letter-spacing: vwXL(letterSpacing(50, 27));
  // padding-right: vwXL(70);
  // padding-bottom: vwXL(2);
  // padding-left: vwXL(15);
  // border: #f8e577 vwXL(4) solid;
  // background: url('~@/assets/images/common/dropdowns_arrow.png') right vwXL(17) top vwXL(20) #fff no-repeat;
  // background-size: vwXL(49) vwXL(25);
  // cursor: pointer;

  @include tablet {
    // height: vwM(70);
    // font-size: vwM(40);
    // letter-spacing: vwM(letterSpacing(50, 40));
    // padding-right: vwM(0);
    // padding-bottom: vwM(2);
    // padding-left: vwM(25);
    // border-width: vwM(4);
    // background-position: right vwM(16) top vwM(20);
    // background-size: vwM(49) vwM(25);
  }
}

button {
  height: vwXL(70);
  color: #eb623c;
  font-size: vwXL(27);
  font-weight: 700;
  letter-spacing: vwXL(letterSpacing(50, 27));
  padding-right: vwXL(22);
  padding-bottom: vwXL(2);
  padding-left: vwXL(24);
  background: #f8e577;
  cursor: pointer;

  @include tablet {
    height: vwM(70);
    font-size: vwM(36);
    letter-spacing: vwM(letterSpacing(50, 36));
    padding-right: vwM(0);
    padding-bottom: vwM(2);
    padding-left: vwM(0);
  }
}

::placeholder {
  color: #999999;
  opacity: 1;
}

:-ms-input-placeholder {
  color: #999999;
}

::-ms-input-placeholder {
  color: #999999;
}

.section__content:not(.section__content--overview) {
  zoom: 0.8;
  @include tablet {
    zoom: 1;
  }
}

#popup {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: auto;
  // min-height: 100%;
  min-height: calc(var(--vh, 1vh) * 100);
  z-index: 2;

  &.fade-leave-active {
  }
}

.popup__container {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  width: 100%;
  height: auto;
  // min-height: 100%;
  min-height: calc(var(--vh, 1vh) * 100);
  overflow: hidden;
  background: rgba(#fff, 0.9);

  @include tablet {
  }
}

.popup__main {
  display: flex;
  flex-direction: column;
  position: relative;
  color: #fff;
  margin: vwXL(100) 0;

  @include tablet {
    margin: vwM(100) 0;
  }
}

.popup__basic {
  width: vwXL(1175);
  min-height: vwXL(588);
  background: #fdf2ef;

  @include tablet {
    width: vwM(884);
    height: auto;
    // height: calc(var(--vh, 1vh) * 100 - vwM(170 * 2));
    min-height: 0;
    // min-height: vwM(900);
    margin: vwM(170) 0;
  }

  &--full {
    @include tablet {
      // min-height: calc(var(--vh, 1vh) * 100 - vwM(170 * 2));
      height: calc(var(--vh, 1vh) * 100 - vwM(170 * 2));
      min-height: vwM(900);
    }
  }

  .popup__content {
    color: #eb623c;
    padding: 0 vwXL(80);

    @include tablet {
      padding: 0 vwM(74);
    }
  }

  .popup__title {
    display: flex;
    align-items: center;
    justify-content: center;

    padding: vwXL(60) 0 0;

    @include tablet {
      padding: vwM(78) 0 0;
    }

    p {
      color: #e72910;
      font-size: vwXL(47);
      font-weight: 700;
      text-align: center;
      letter-spacing: vwXL(letterSpacing(50, 47));
      transform: scaleX(1.05);

      @include tablet {
        font-size: vwM(68);
        letter-spacing: vwM(letterSpacing(50, 68));
      }
    }
  }
}

.popup__header {
  display: flex;
  align-items: stretch;
  justify-content: center;
}

.popup__close {
  position: absolute;
  top: -60px;
  right: -15px;
  width: 43px;
  height: 43px;
  background-image: url('~@/assets/images/popup_close.png');
  background-repeat: no-repeat;
  background-size: contain;
  z-index: 1;
  @include tabletX {
    right: 2%;
  }
  @include tablet {
    width: vwM(86);
    height: vwM(86);
    top: vwM(-70);
    right: vwM(42);
  }
}

// .popup__main .popup__content {
.popup__main {
  opacity: 0;
  transform: translateY(vwM(100));
  transition: all 0.5s ease;
  transition-property: opacity, transform;
  zoom: 0.8;
  @include tablet {
    zoom: 1;
  }
}

// #popup.popup--ready .popup__main .popup__content {
#popup.popup--ready .popup__main {
  opacity: 1;
  transform: translateY(0);
}

.popup__content {
  @include tabletX {
    width: 90%;
    margin: 0 auto;
  }
  .secure-text {
    width: 100%;
    max-width: 1110px;
    font-size: 17px;
    font-weight: 600;
    color: #3f3f3f;
    text-align: justify;
    line-height: lineHeight(17, 25);
    letter-spacing: letterSpacing(100, 17px);
    margin: 30px auto 0 auto;
    @include tablet {
      // width: 90%;
      font-size: 23px;
      line-height: lineHeight(23, 35);
      letter-spacing: letterSpacing(100, 18px);
    }
    @include mobile {
      font-size: vwMB(23);
    }
    .highlight {
      color: #870000;
    }
  }
}

.move-in {
  @include moveFadeDefault($value: var(--move-y));

  @at-root .section.play .move-in {
    @include moveFadeIn();
  }
}

.fade-enter-active,
.fade-leave-active {
  transition-property: opacity;
  transition-duration: $primaryDuration;
  transition-timing-function: ease;
}

.fade-enter-active {
  transition-delay: 0s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}

.animate__delay-02s {
  animation-delay: 0.2s;
}
.custom-duration {
  --animate-duration: 1500ms;
}
.custom-timing {
  animation-timing-function: cubic-bezier(0, 0, 0, 1.01) !important;
}
</style>
